import request from '@/utils/request'

// 发送验证码
export function sendCode(phone) {
  return request({
    url: '/api/music/phone/',
    method: 'post',
    data: { phone }
  })
}

// 登录
export function login(data) {
  return request({
    url: '/api/music/login/',
    method: 'post',
    data
  })
}

// 注册
export function register(data) {
  return request({
    url: '/api/music/register/',
    method: 'post',
    data
  })
}

// 重置密码
export function resetPassword(data) {
  return request({
    url: '/api/music/forgot_password/',
    method: 'post',
    data
  })
} 


// WEBPACK FOOTER //
// ./src/api/auth.js